
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as PeopleIcon } from "../fontello/icons/svg/ic_people.svg"


const People = ({ ...props }) => (
  <SvgIcon
    component={PeopleIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default People
